import type { SupportTicketDetailSchema } from '@/_containers/support/shared/schemas/support-query-schema';
import {
  SupportTicketPriority,
  SupportTicketSource,
  SupportTicketStatus,
} from '@/_containers/support/shared/schemas/support-query-schema';

// Concrete default values matching SupportTicketDetailSchema
export const defaultValues: Readonly<SupportTicketDetailSchema> = {
  id: -1,
  subject: '',
  description: '',
  description_text: '',
  status: SupportTicketStatus.OPEN,
  priority: SupportTicketPriority.LOW,
  source: SupportTicketSource.EMAIL,
  requester_id: 0,
  requester: null,
  company: null,
  responder_id: null,
  company_id: null,
  product_id: null,
  group_id: null,
  due_by: null,
  fr_due_by: null,
  is_escalated: false,
  created_at: '',
  updated_at: '',
  tags: [],
  spam: false,
  type: null,
  custom_fields: null,

  to_emails: null,
  cc_emails: null,
  bcc_emails: null,
  conversations: [],
  sla_policy: null,
  escalated_at: null,
  attachments: [],
} as const;
